import api, { authHeaders } from './base';

export const createInstallationByCustomerId = async (id, data) => {
    return await api.post(`/installation/${id}`, data, { headers: authHeaders() });
};

export const fetchInstallationById = async (id) => {
    return await api.get(`/installation/${id}`, { headers: authHeaders() });
};

export const updateInstallationById = async (id, data) => {
    return await api.put(`/installation/${id}`, data, { headers: authHeaders() });
};

export const fetchInstallationList = async (page = 1, limit = 10, status = '', search = '') => {
    return await api.get('/installation', {
        headers: authHeaders(),
        params: { page, limit, status, search: search.trim() || undefined },
    });
};

export const installationStatusUpdate = async (id, status) => {
    return await api.put(`/installation/${id}/status/${status}`, null, { headers: authHeaders() });
};